import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colorsPalette } from '../../theme';

const useStyles = (anchorWidth) =>
  makeStyles((theme: Theme) => {
    return createStyles({
      select: {
        color: colorsPalette.white,

        '&:focus': {
          backgroundColor: 'transparent',
        },
      },
      menu: {
        width: anchorWidth,
        background: colorsPalette.violetDark,
      },
      selectHeader: {
        display: 'flex',
        alignItems: 'center',
      },
      selectItem: {
        fontSize: 12,
        fontWeight: 'bold',
        color: colorsPalette.gray,
        [theme.breakpoints.up('md')]: {
          fontSize: 16,
        },
      },
      chevronIcon: {
        fill: colorsPalette.blue,
      },
      popoverHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 10,

        '& $selectItem': {
          fontSize: 18,
        },
      },
      popper: {
        padding: 20,
        background: colorsPalette.violetAnalyticsCard,
        borderRadius: 20,
        boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.4)',
        width: anchorWidth,
        marginTop: -45,
        zIndex: 2,
      },
      paper: {
        margin: 0,
        background: colorsPalette.violetAnalyticsCard,
        borderRadius: 0,
        boxShadow: 'none',
      },
      popperDisablePortal: {
        position: 'static',
        width: '100% !important',
      },
      option: {
        borderRadius: 5,
        marginBottom: 5,
        padding: 0,

        '&:last-item': {
          marginBottom: 0,
        },
      },
      optionInner: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: 5,
        padding: 11,
      },
      selected: {
        background: colorsPalette.blue,
      },
      optionText: {},
      input: {
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: 50,
        padding: '0 15px',
        height: 45,
        width: '100%',
        marginBottom: 20,
      },
      inputHided: {
        height: 0,
        padding: 0,
        marginBottom: 0,
        opacity: 0,
        marginTop: -20,

        '& input': {
          cursor: 'default',
        },
      },
      selectItems: {
        maxWidth: 30,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',

        [theme.breakpoints.up('md')]: {
          maxWidth: 180,
        },
      },
    });
  });

export default useStyles;
